import React from 'react';

const Card = ({ 
  children, 
  title, 
  description, 
  icon: Icon, 
  className = '', 
  hover = false 
}) => {
  return (
    <div className={`
      bg-white rounded-lg shadow-md p-6 
      ${hover ? 'transition-all duration-300 hover:shadow-lg hover:-translate-y-1' : ''}
      ${className}
    `}>
      {Icon && (
        <div className="mb-4 text-blue-600">
          <Icon size={48} />
        </div>
      )}
      {title && <h3 className="text-xl font-bold mb-2">{title}</h3>}
      {description && <p className="text-gray-600 mb-4">{description}</p>}
      {children}
    </div>
  );
};

export default Card;